<template>
    <div>
        <Pane title="重新提交竣工报告" :showRemarks="false">
            <template>重新发起竣工报告流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form
                    :form="form"
                    layout="horizontal"
                    :colon="false"
                    label-align="right"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 17 }"
                >
                    <a-row :gutter="16">
                        <a-col :span="24">
                            <a-form-item label="项目名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                                <a-input v-decorator="['projectName']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="设计编码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                <a-input v-decorator="['designNo']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="设计阶段">
                                <a-input v-decorator="['designPhase']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="管理级别" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                <a-radio-group v-decorator="['manageLevel']" disabled>
                                    <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目类别">
                                <a-select v-decorator="['prjCategory']" disabled placeholder="">
                                    <a-select-option v-for="item in prjCategoryList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目负责人" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                <a-input v-decorator="['prjLeaderName']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="公司领导">
                                <EmployeeSelector
                                    :single="true"
                                    @change="handleLeaderChange"
                                    :value="leaderList"
                                >
                                    <a-button block style="text-align: left">{{ leaderList.length ? leaderList[0].name : '请选择公司领导' }}</a-button>
                                </EmployeeSelector>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="竣工依据" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                                <a-textarea v-decorator="['completionBasis', { rules: [{ required: true, message: '请输入竣工依据' }] }]" :rows="4" placeholder="请输入竣工依据" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                                <a-textarea v-decorator="['remark']" :rows="2" placeholder="请输入备注" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="盖章附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                                <Attachment
                                    :editable="true"
                                    :fileList="fileList"
                                    @change="(v) => { fileList = v; stampAttachmentList = v.map(f => f.completePath || f) }"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { fetchCompletionReportDetail, resubmitCompletionReport } from "@/api/project-execute/completion-report";
import { mapMutations, mapGetters, mapState } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import Attachment from "@/components/attachment";

export default {
    name: "CompletionReportReapply",
    components: { EmployeeSelector, Attachment },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            submitting: false,
            id: "",
            phaseId: "",
            taskId: "",
            instanceId: "",
            leaderList: [],
            fileList: [],
            stampAttachmentList: [],
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel") || [];
        },
        prjCategoryList() {
            return this.findDataDict("cosys.prjCategory") || [];
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail(id) {
            this.loading = true;
            fetchCompletionReportDetail(id)
                .then((data) => {
                    if (!data) return;
                    this.phaseId = data.phaseId || "";
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.form.setFieldsValue({
                                projectName: data.projectName || "",
                                designNo: data.designNo || "",
                                designPhase: data.designPhase || "",
                                manageLevel: data.manageLevel || "",
                                prjCategory: data.prjCategory || "",
                                prjLeaderName: data.prjLeaderName || "",
                                completionBasis: data.completionBasis || "",
                                remark: data.remark || "",
                            });
                        });
                    });
                    if (data.companyLeaderId && data.companyLeaderName) {
                        this.leaderList = [{ userId: data.companyLeaderId, name: data.companyLeaderName }];
                    }
                    // 处理附件
                    const stampAttachmentPaths = data.stampAttachmentPaths
                    if (stampAttachmentPaths) {
                        const urls = String(stampAttachmentPaths).split(',').filter(Boolean)
                        let names = []
                        let ids = []
                        if (data.stampAttachment) {
                            try {
                                const parsed = typeof data.stampAttachment === 'string' ? JSON.parse(data.stampAttachment) : data.stampAttachment
                                if (Array.isArray(parsed)) {
                                    names = parsed.map(item => item.name || '')
                                    ids = parsed.map(item => item.id || '')
                                }
                            } catch (e) {
                                // JSON 解析失败，忽略
                            }
                        }
                        this.fileList = urls.map((url, i) => ({ completePath: url.trim(), name: names[i] || '', id: ids[i] || '' }))
                        this.stampAttachmentList = urls.map(url => url.trim())
                    } else if (data.stampAttachment) {
                        let attachList = []
                        try {
                            const parsed = typeof data.stampAttachment === 'string' ? JSON.parse(data.stampAttachment) : data.stampAttachment
                            attachList = Array.isArray(parsed) ? parsed : []
                        } catch {
                            attachList = data.stampAttachment.split(',').filter(Boolean).map(p => ({ id: p, completePath: p }))
                        }
                        this.fileList = attachList.map(item => ({ completePath: item.completePath || item.url || item.id || item, name: item.name || '', id: item.id || '' }))
                        this.stampAttachmentList = attachList.map(item => item.completePath || item.url || item.id || item)
                    }
                })
                .catch(() => {
                    this.$message.error("获取竣工报告详情失败");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleLeaderChange(arr) {
            this.leaderList = arr.length ? arr : [];
        },
        submitReview() {
            this.form.validateFields((err, formValues) => {
                if (err) return;

                this.submitting = true;
                const params = {
                    id: this.id,
                    phaseId: this.phaseId,
                    ...formValues,
                    companyLeaderId: this.leaderList[0]?.userId,
                    companyLeaderName: this.leaderList[0]?.name,
                    stampAttachment: this.fileList.length ? JSON.stringify(this.fileList.map(f => ({ id: f.id || f.completePath || f.url || f.path || f, name: f.name || '' }))) : '',
                    stampAttachmentPaths: this.stampAttachmentList.join(','),
                };

                resubmitCompletionReport(params)
                    .then(() => {
                        this.$close(this.$route.path, "/approval/task");
                    })
                    .catch((e) => {
                        console.error("提交失败详情", e);
                        this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
